export default "__VITE_ASSET__BssN8Kfo__"